/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Plugin, PluginKey } from "@tiptap/pm/state";
import { getAttributes } from "@tiptap/core";

export const clickHandler = (options) => {
    return new Plugin({
        key: new PluginKey("handleClickLink"),
        props: {
            handleClick: (view, pos, event) => {
                console.log("click simplicity-link");
                // var _a, _b;
                if (event.button !== 0) {
                    return false;
                }
                const eventTarget = event.target;
                if (eventTarget.nodeName !== "A") {
                    return false;
                }
                const attrs = getAttributes(view.state, options.type.name);
                const link = event.target;

                // const href = (_a = link === null || link === undefined ? undefined : link.href) !== null && _a !== undefined ? _a : attrs.href;
                // const target = (_b = link === null || link === undefined ? undefined : link.target) !== null && _b !== undefined ? _b : attrs.target;

                const href = link?.href ?? attrs.href;
                const target = link.target ?? attrs.target;

                if (link && href) {
                    if (view.editable) {
                        window.open(href, target);
                    }
                    return true;
                }
                return false;
            },
        },
    });
};
